import type { FC } from 'react';

import { getMediaUrl } from 'utils/assets';
import { Translation } from 'utils/translations';

import styles from './EmptyState.module.scss';

const ProvidersEmptyState: FC = () => (
  <div className={styles['providers-empty-state']}>
    <img
      src={getMediaUrl('yellow/search-not-found.webp')}
      alt="no providers found"
    />
    <p className={styles['empty-providers-text']}>
      <Translation message="empty_providers_message" />
    </p>
  </div>
);

export default ProvidersEmptyState;
